import { handleActions } from 'redux-actions'
import { setStore } from './actions'

const initialState = null

export default handleActions({
  [setStore]: (state, { payload: { store } = {}}) => store ? ({ ...store }) : initialState
}, initialState)
